import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import api from "@/lib/api";
import AIContentBlock from "@/components/AIContentBlock";

export default function Genres() {
  const [genres, setGenres] = useState([]);

  useEffect(() => {
    api.get("/genres").then((r) => setGenres(r.data)).catch(console.error);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="genres-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-slate-500 mb-3">Genres &amp; Traditions</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900">Every Culture Has <span className="gradient-text">a Rhythm.</span></h1>
      <p className="mt-3 text-slate-600 max-w-2xl">From living village traditions to global movements — documented in their cultural context, with respect for the communities that carry them.</p>

      <AIContentBlock pageKey="genres" topic="Music genres and traditions of the world" imgQuery="traditional musicians cultural performance" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {genres.map((g) => (
          <Link key={g.slug} to={`/genres/${g.slug}`} data-testid={`genre-list-card-${g.slug}`} className="card-lift bg-white rounded-3xl border border-slate-100 overflow-hidden group">
            <div className="h-40 overflow-hidden relative">
              <img src={g.image} alt={g.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-white/90 backdrop-blur text-[10px] font-black text-emerald-700 uppercase tracking-wide">{g.preservation_status}</span>
            </div>
            <div className="p-5">
              <h2 className="font-display text-xl font-black text-slate-900">{g.name}</h2>
              <p className="text-xs text-slate-500 flex items-center gap-1 mt-1"><MapPin className="w-3 h-3 text-pink-500" /> {g.origin_place}, {g.origin_country}</p>
              <p className="text-sm text-slate-600 mt-3 line-clamp-2">{g.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
